import { Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment-timezone';
import { StagingService } from '../staging.service';

/**
 * Member trip stats (eligibility window, quota usage, per-status counts).
 * Mirrors the TripStatsPanel in the MemberCare app.
 */
@Component({
  selector: 'app-member-trip-stats',
  templateUrl: './member-trip-stats.component.html'
})
export class MemberTripStatsComponent implements OnChanges, OnDestroy {
  @Input() clientId: string;
  @Input() timeZone: string;

  stats: any = null;
  isLoading = false;
  hasError = false;
  private request: Subscription;

  counts: any[] = [];

  constructor(private stagingService: StagingService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.clientId) {
      this.loadStats();
    }
  }

  loadStats() {
    if (this.request) this.request.unsubscribe();
    this.stats = null;
    this.counts = [];
    this.hasError = false;
    if (!this.clientId) return;

    this.isLoading = true;
    this.request = this.stagingService.getMemberTripStats(this.clientId).subscribe(
      (data) => {
        this.isLoading = false;
        this.stats = data || {};
        this.updateCounts();
      },
      () => {
        this.isLoading = false;
        this.hasError = true;
      }
    );
  }

  updateCounts() {
    const s = this.stats || {};
    this.counts = [
      { label: 'Total', value: s.total, color: 'text-[#293562]' },
      { label: 'Confirmed', value: s.confirmed, color: 'text-emerald-700' },
      { label: 'Not Authorized', value: s.unconfirmed, color: 'text-amber-700' },
      { label: 'Trip Intake', value: s.trip_intake, color: 'text-sky-700' }
    ];
  }

  get eligibility() {
    return (this.stats && this.stats.eligibility) || null;
  }

  get quota(): number {
    return this.eligibility && this.eligibility.tripQuota != null ? Number(this.eligibility.tripQuota) : null;
  }

  get usedPercent(): number {
    const used = (this.stats && this.stats.used) || 0;
    return this.quota ? Math.min(100, Math.round((used / this.quota) * 100)) : 0;
  }

  get isEligible(): boolean {
    return !!this.eligibility && this.eligibility.status === 'eligible';
  }

  formatDate(value): string {
    if (!value) return '';
    const date = this.timeZone ? moment(value).tz(this.timeZone) : moment(value);
    return date.format('MMM D, YYYY');
  }

  statusLabel(status: string): string {
    return (status || '').replace(/_/g, ' ');
  }

  ngOnDestroy() {
    if (this.request) this.request.unsubscribe();
  }
}
